// Please set up a synthetic test if you add a new Zendesk link! Each test can only make requests to a max of 10 urls
// These tests let us know if the zendesk link breaks i.e. if the link changes
// https://app.datadoghq.com/synthetics/details/5yw-rua-w5q?from_ts=1739880552761&to_ts=1740485352761&live=true
// https://app.datadoghq.com/synthetics/details/qqr-ze6-dni?from_ts=1739880554413&to_ts=1740485354413&live=true
// https://app.datadoghq.com/synthetics/details/pnk-kcv-4ny?from_ts=1739880556130&to_ts=1740485356130&live=true

import { HELP_ARTICLES } from '@/constants/helpUrls.ts';

export const FOOTER_LINKS = {
  ABOUT_LINK: 'https://news.depop.com/who-we-are/about/',
  CAREERS_LINK: 'https://depopcareers.com/',
  BLOG_LINK: '/blog/',
  NEWS_LINK: 'https://news.depop.com',
  SUPPORT_LINK: HELP_ARTICLES.HELP_HOME,
  SAFETY_LINK: 'https://safety.depop.com',
};

export const SOCIAL_MEDIA_SITES = {
  FACEBOOK: 'https://facebook.com/depop',
  INSTAGRAM: 'https://instagram.com/depop/',
  TIKTOK: 'https://www.tiktok.com/@depop',
  X: 'https://x.com/askdepop/',
};
